import { useTranslation } from "src/hooks/translation";

import './style.scss';

interface IProps {
    closePopup: () => void;
};

const SuccessPopup = ({ closePopup }: IProps) => {
    const t = useTranslation();

    return (
        <div className="B-popup-content B-popup-small B-betslip-success-popup">
            <h3 className="B-popup-title">{t('Success')}</h3>
            <div className="B-popup-main-content">
                <i className="global-icon icon-checkmark B-icon"/>
                <p className="text-center">{t('Free bet placed successfully')}</p>
            </div>

            <button className="B-popup-confirm-button" onClick={() => closePopup()}>{t('Done')}</button>
        </div>
    );
};

export default SuccessPopup;
